export enum TerminationReasonEnum {
    ObitoComDeclaracaoDeObitoFornecidaPeloMedicoAssistente = 18,
    ObitoComDeclaracaoDeObitoFornecidaPeloInstitutoMedicoLegalIML = 19,
    ObitoComDeclaracaoDeObitoFornecidaPeloServiçoDeVerificacaoDeObitoSVO = 20
}